import React from 'react';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

const Layout = () => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();

  const handleContinue = async () => {
    await onSubmit();
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'subtitle'} />
          <MetaControlField attr="mailingAddressIsSameAsPhysical" />
          <MetaLayoutRemainingFields horizontal noAccordion />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          label="Save"
          onClick={handleContinue}
          disabled={saving}
        />
      </DialogActions>
    </>
  );
};

export default Layout;
